var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-wrapper grid-wrapper--col__4"},_vm._l((_vm.brandsList),function(brand,i){return _c('brand-tile',{directives:[{name:"trackevent",rawName:"v-trackevent",value:({
      action: 'Homepage Featured Brand Click',
      properties: {
        brand_name: brand.brand_name,
        minimum_order_value: brand.minimum_order_value,
      },
    }),expression:"{\n      action: 'Homepage Featured Brand Click',\n      properties: {\n        brand_name: brand.brand_name,\n        minimum_order_value: brand.minimum_order_value,\n      },\n    }"}],key:'brand_' + brand.id + '_' + i,attrs:{"data":brand,"borders":true}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }